
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons'
import { styled } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

import { Icon } from '../../Icon/Icon'
import { IconButton } from '../../IconButton/IconButton'
import { useRowActionsContext } from './RowActionsContext'

export type RowHotActionGridCellProps = GridRenderCellParams & {
  //
}

export const RowHotActionGridCell: React.FC<RowHotActionGridCellProps> = (props) => {
  const { row } = props
  const { hotAction } = useRowActionsContext()

  return row.hasHotAction ? (
    <StyledCell>
      {hotAction && <IconButton
        tooltipTitle={hotAction?.label || ''}
        onClick={(ev) => {
          ev.stopPropagation()
          ev.preventDefault()
          
          hotAction.onClick(row)
        }}
        disabled={hotAction?.disabled}
      >
        <StyledActionIcon icon={hotAction?.icon ?? faUpRightFromSquare} />
      </IconButton>
      }
    </StyledCell>
  ) : null
}

const StyledCell = styled('div')`
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledActionIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(16)};
  width: ${props => props.theme.typography.pxToRem(16)};
  height: ${props => props.theme.typography.pxToRem(16)};
  transform: none !important;
`

